// Koordinat PERKIRAAN (bukan hasil survei/data resmi BIG/Disdukcapil) untuk
// semua 47 kecamatan di Kabupaten Sukabumi - dipakai untuk plotting pin di
// peta utama (SebaranPeta.jsx) dan peta mini Dashboard (SebaranPetaMini.jsx).
// Disusun dari pengetahuan geografis umum, dikelompokkan per Dapil (kecamatan
// dalam satu Dapil letaknya berdekatan secara geografis). User sudah
// menyetujui memakai perkiraan ini sambil menunggu data koordinat resmi -
// kalau nanti ada data itu, cukup ganti nilai di file ini saja.
export const KECAMATAN_COORDS = [
  // Dapil 1 - pesisir barat/barat laut
  { name: 'Palabuhanratu', coords: [-6.9856, 106.5511] },
  { name: 'Simpenan', coords: [-7.0264, 106.5292] },
  { name: 'Cikakak', coords: [-6.9556, 106.5000] },
  { name: 'Cisolok', coords: [-6.9928, 106.4419] },
  { name: 'Bantargadung', coords: [-7.0011, 106.6739] },
  { name: 'Warungkiara', coords: [-6.9236, 106.6206] },
  // Dapil 2 - utara, berbatasan dengan Bogor
  { name: 'Parungkuda', coords: [-6.8214, 106.7783] },
  { name: 'Bojonggenteng', coords: [-6.8494, 106.7333] },
  { name: 'Parakansalak', coords: [-6.8036, 106.7333] },
  { name: 'Cicurug', coords: [-6.7364, 106.7742] },
  { name: 'Cidahu', coords: [-6.7481, 106.8214] },
  { name: 'Kalapanunggal', coords: [-6.7550, 106.6667] },
  { name: 'Kabandungan', coords: [-6.7444, 106.6169] },
  { name: 'Ciambar', coords: [-6.8500, 106.7000] },
  // Dapil 3 - tengah
  { name: 'Cikidang', coords: [-6.9394, 106.6669] },
  { name: 'Cikembar', coords: [-6.9634, 106.8317] },
  { name: 'Cibadak', coords: [-6.8878, 106.7811] },
  { name: 'Nagrak', coords: [-6.8339, 106.7514] },
  { name: 'Cicantayan', coords: [-6.9256, 106.8483] },
  { name: 'Caringin', coords: [-6.9500, 106.7833] },
  // Dapil 4 - tengah-timur, sekitar Kota Sukabumi
  { name: 'Gunungguruh', coords: [-6.9333, 106.8833] },
  { name: 'Cisaat', coords: [-6.9014, 106.8994] },
  { name: 'Kadudampit', coords: [-6.8783, 106.8933] },
  { name: 'Sukabumi', coords: [-6.9175, 106.9269] },
  { name: 'Sukaraja', coords: [-6.8611, 106.9611] },
  { name: 'Kebonpedes', coords: [-6.9139, 106.9083] },
  { name: 'Cireunghas', coords: [-6.9525, 106.9711] },
  { name: 'Sukalarang', coords: [-6.8422, 106.9689] },
  { name: 'Gegerbitung', coords: [-6.9694, 106.9906] },
  // Dapil 5 - selatan-tengah, pegunungan (area Jampang Tengah)
  { name: 'Lengkong', coords: [-7.0333, 106.8667] },
  { name: 'Jampangtengah', coords: [-7.0667, 106.9333] },
  { name: 'Pabuaran', coords: [-7.0806, 106.8306] },
  { name: 'Purabaya', coords: [-7.1167, 106.8667] },
  { name: 'Nyalindung', coords: [-6.9944, 106.9417] },
  { name: 'Sagaranten', coords: [-7.0667, 106.8500] },
  { name: 'Curugkembar', coords: [-7.1000, 106.8000] },
  { name: 'Cidolog', coords: [-7.1667, 106.8333] },
  { name: 'Cidadap', coords: [-7.2000, 106.8667] },
  // Dapil 6 - pesisir selatan (area Jampang Kulon)
  { name: 'Waluran', coords: [-7.1167, 106.6167] },
  { name: 'Ciemas', coords: [-7.1667, 106.5167] },
  { name: 'Jampangkulon', coords: [-7.2456, 106.6817] },
  { name: 'Cimanggu', coords: [-7.2167, 106.6167] },
  { name: 'Kalibunder', coords: [-7.2333, 106.7167] },
  { name: 'Tegalbuleud', coords: [-7.3167, 106.7500] },
  { name: 'Cibitung', coords: [-7.3333, 106.6667] },
  { name: 'Surade', coords: [-7.3167, 106.6167] },
  { name: 'Ciracap', coords: [-7.3500, 106.5833] },
];
